module.exports = __webpack_public_path__ + "wxMicroService/img/abanner_02@2x.9480db2d.jpg";